import { render } from "./BootstrapModal.vue?vue&type=template&id=7fd7d0da"
import script from "./BootstrapModal.vue?vue&type=script&lang=js"
export * from "./BootstrapModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__